import React from 'react';
import { History } from 'history';
import { useTranslation } from 'react-i18next';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';
import {
  AccountInfoType,
  AccountUserType,
  BreadcrumpDataType,
  ConfirmationType,
} from '../../../shared/types';
import DesignThemes from './screens/DesignThemes';
import AccountInfo from './screens/accountinfo';
import { BlockedSentimentTopic } from './screens/blockedsentimenttopic';
import CustomDomainMapping from './screens/customdomainmapping';
// import Blocklist from './screens/blocklist';
import CustomFields from './screens/customfields';
import DKIMsettings from './screens/dkimsettings';
import Integrations from './screens/integrations';
import GlobalSurveyLimit from './screens/surveylimit';
import Tags from './screens/tags/screens';
import Templates from './screens/templates';
import TranslationSettings from './screens/translationsettings';
import UserManagement from './screens/user';
import { useGetTenantInfo } from './hooks';
import {
  SettingsContainer,
  SettingsItemContainer,
  SettingsListContainer,
} from './styles';
import { settingsData } from './constants';

type SettingsRoutesProps = {
  setBreadcrumpData?: (
    str: BreadcrumpDataType | React.SetStateAction<BreadcrumpDataType>,
  ) => void;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
  accountInfo?: AccountInfoType;
  breadcrumpData?: BreadcrumpDataType;
  currentAccountUser?: AccountUserType;
};

const SettingsRoutes = ({
  setConfirmationData,
  accountInfo,
  breadcrumpData,
  setBreadcrumpData,
  currentAccountUser,
}: SettingsRoutesProps) => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

  const {
    push,
    location: { pathname },
  }: History = useHistory();

  const { data: tenantInfo } = useGetTenantInfo();

  const isFreddyEnabled = tenantInfo?.account_meta?.enabled_features?.includes(
    'freddy_response_analysis',
  );

  const filteredSettingsData = !isFreddyEnabled
    ? settingsData.filter((d) => d.id !== 'blockedSentimentTopic')
    : settingsData;

  return (
    <SettingsContainer>
      {!(pathname.indexOf('profile') > -1) ? (
        <SettingsListContainer>
          {filteredSettingsData.map((setting) => (
            <div
              id={setting.id}
              className={`settings-item ${
                pathname.indexOf(`${path}${setting.href}`) >= 0 ? 'active' : ''
              }`}
              onClick={() => push(`${path}${setting.href}`)}
              key={setting.id}
            >
              <div className="settings-item-icon">
                <img src={`${setting.icon}`} alt={`${t(setting.name)}`} />
              </div>
              <div className="settings-item-content">
                <div className="settings-item-text">{t(`${setting.name}`)}</div>
                <div className="settings-item-description">
                  {t(`${setting.description}`)}
                </div>
              </div>
            </div>
          ))}
        </SettingsListContainer>
      ) : null}
      <SettingsItemContainer>
        <Switch>
          <Route path={`${path}/limit`}>
            <GlobalSurveyLimit accountInfo={accountInfo} />
          </Route>
          <Route path={`${path}/translation-settings`}>
            <TranslationSettings
              setConfirmationData={setConfirmationData}
              accountInfo={accountInfo}
            />
          </Route>
          <Route path={`${path}/user`}>
            <UserManagement accountInfo={accountInfo} />
          </Route>
          <Route exact path={`${path}/templates`}>
            <Templates setConfirmationData={setConfirmationData} />
          </Route>
          <Route exact path={`${path}/design-themes`}>
            <DesignThemes
              setConfirmationData={setConfirmationData}
              accountInfo={accountInfo}
              setBreadcrumpData={setBreadcrumpData}
              breadcrumpData={breadcrumpData}
              currentAccountUser={currentAccountUser}
              hostConfig={{}}
            />
          </Route>
          {/* <Route path={`${path}/blocklist`}>
            <Blocklist />
          </Route> */}
          <Route path={`${path}/customfields`}>
            <CustomFields setConfirmationData={setConfirmationData} />
          </Route>
          <Route path={`${path}/tags`}>
            <Tags setConfirmationData={setConfirmationData} />
          </Route>
          {isFreddyEnabled && (
            <Route path={`${path}/blocked-sentiment-topic`}>
              <BlockedSentimentTopic
                setConfirmationData={setConfirmationData}
                accountInfo={accountInfo}
              />
            </Route>
          )}

          <Route path={`${path}/dkim`}>
            <DKIMsettings />
          </Route>
          <Route path={`${path}/custom-domain`}>
            <CustomDomainMapping />
          </Route>
          <Route path={`${path}/integrations`}>
            <Integrations />
          </Route>
          <Route path={`${path}/account`}>
            <AccountInfo setConfirmationData={setConfirmationData} />
          </Route>
          <Route path={path}>
            <Redirect to={`${path}/limit`} />
          </Route>
        </Switch>
      </SettingsItemContainer>
    </SettingsContainer>
  );
};

export default SettingsRoutes;
